"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var CallPopupAction;
(function (CallPopupAction) {
    CallPopupAction.ON_SET_ACTIVE = 'ON_SET_ACTIVE';
    CallPopupAction.ON_CALL_POPUP_CLOSE_CLICK = 'ON_CALL_POPUP_CLOSE_CLICK';
    CallPopupAction.onSetActive = typesafe_actions_1.createAction(CallPopupAction.ON_SET_ACTIVE, function (resolve) { return function (state) { return resolve(state); }; });
    CallPopupAction.onCallPopupCloseClick = typesafe_actions_1.createAction(CallPopupAction.ON_CALL_POPUP_CLOSE_CLICK, function (resolve) { return function () { return resolve(); }; });
})(CallPopupAction || (CallPopupAction = {}));
exports.default = CallPopupAction;
